import { ConvexReactClient } from "convex/react";
import { api } from "../../convex/_generated/api";

if (!import.meta.env.VITE_CONVEX_URL) {
  throw new Error("Missing VITE_CONVEX_URL in environment variables");
}

export const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL);
export { api };